module.exports = __webpack_public_path__ + "public/img/bannar-fuping-phone.910e6eab.png";